import Nullstack from 'nullstack';
export default function IconScreenShare({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-screen-share",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "20",
    x2: "17",
    y2: "20"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "16",
    x2: "9",
    y2: "20"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "16",
    x2: "15",
    y2: "20"
  }), "   ", Nullstack.element("path", {
    d: "M17 4h4v4"
  }), "   ", Nullstack.element("path", {
    d: "M16 9l5 -5"
  }), " ");
}